import React from "react";
import { withRouter } from "react-router-dom";
import {registerNavigation, uiFlowBenAdmin} from "../utils/common";
import {connect} from "react-redux";

const mapStateToProps = (state, ownProps) => {
    const {initialData} = state;
    const {uiFlow} = initialData;
    return {
        token: initialData.token,
        isBenAdmin: uiFlow === uiFlowBenAdmin,
        ...ownProps
    }
};

class RecordNavigation extends React.Component {
    componentDidUpdate(prevProps, prevState, snapshot) {
        const {token, isBenAdmin, location} = this.props;
        if (!isBenAdmin && location.pathname !== prevProps.location.pathname) {
            registerNavigation(token);
        }
    }

    render() {
        return this.props.children;
    }
}

export default withRouter(connect(mapStateToProps)(RecordNavigation));